import React, { useState } from "react";
import { Theme, useTheme } from "@mui/material/styles";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import styled from "styled-components";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const MultiSelectCheckboxDropdown= ({
  options_label = "label",
  key = "key",
  options = [],
  selectedValues = [],
  handleChange,
  className = "",
  keyToChange,
  extraParams = {},
  width = 550,
}) => {
  const theme = useTheme();

  const handleSelectChange = (event) => {
    const {
      target: { value },
    } = event;
    handleChange(
      keyToChange,
      typeof value === "string" ? value.split(",") : value,
      extraParams
    );
  };

  const getStyles = (name) => {
    return {
      fontWeight:
        selectedValues.indexOf(name) === -1
          ? theme.typography.fontWeightRegular
          : theme.typography.fontWeightMedium,
    };
  };

  return (
    <SelectViewer className={className} width={width}>
      <FormControl sx={{ width }}>
        <Select
          multiple
          value={selectedValues}
          onChange={handleSelectChange}
          input={<OutlinedInput/>}
          MenuProps={MenuProps}
          sx={{
            '.MuiSelect-select': {
              padding: '14px !important',
            },
          }}
        >
          {options.map((option) => (
            <MenuItem key={option[key]} value={option[options_label]} style={getStyles(option[options_label])}>
              {option[options_label]}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </SelectViewer>
  );
};

const SelectViewer = styled.div`
  .MuiFormControl-root {
    width: ${(props) => props.width}px;
    margin-bottom: 20px;
  }
`;

export default MultiSelectCheckboxDropdown;
